/*
 * ── Entitlement (feature-flag) helpers ──
 *
 * The resolved flag map rides down on the user object (user.entitlements),
 * embedded by the backend at login / /auth/me. A tenant with no entitlement
 * record is grandfathered — the backend sends every flag ON, and when the map
 * is missing entirely we also treat everything as ON so nothing ever hides by
 * accident.
 *
 * ON means: no change to how the feature behaves. OFF means: hide it in the UI
 * (nav + entry points) AND the backend blocks the route/action. This module is
 * the single client-side read point — never inspect user.entitlements directly
 * at a call site.
 */

/**
 * @param {Object} user  auth user object (carries `.entitlements`)
 * @param {string} flag  flag key, e.g. 'automations'
 * @returns {boolean} true when the feature is available
 */
export function hasFlag(user, flag) {
  if (!flag) return true;
  const ents = user?.entitlements;
  if (!ents) return true; // grandfathered / not yet loaded → never hide
  return ents[flag] !== false;
}
